import { SET_ACCOUNT_INFO } from '../constants/ActionTypes'

/**
 * @typedef {import('../types/system').Account} Account
 * @typedef {import('../index').PltrAction} PltrAction
 */

/**
 * @type {Account}
 */
const INITIAL_STATE = {
  subscriptions: {
    proSubscription: null,
    plottrSubscription: null,
  },
}

/**
 * @param {Account} state
 * @param {PltrAction} action
 * @return {Account}
 */
const accountReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ACCOUNT_INFO: {
      const { proSubscription, plottrSubscription } = action.info
      return {
        subscriptions: {
          proSubscription: proSubscription ?? null,
          plottrSubscription: plottrSubscription ?? null,
        },
      }
    }

    default:
      return state
  }
}

export default accountReducer
